import { Injectable } from '@angular/core';

import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';
import { MessengerService } from '../messenger/messenger.service';

@Injectable()
export class DynamicContentService extends RestfulService<Models.DynamicContent> {

  constructor(private restService: RestService, private ms: MessengerService) {
    super(Models.DynamicContent);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('dynamic-contents');
  }

  // gets dynamic-content, its children, its translations and if level > 1 its dynamic-content-parent

  public async getAssigned(id): Promise<any> {
    const query = { _id: id, OwnerOrganisationID: this.ms.getOrganisation().OrganisationID };
    if (!id) {
      return {};
    }
    const content = await super.find(0, 1, query);

    if (!content?.data?.length) {
      throw Error('not found - or not allowed');
    }
    const thisContent = content.data[0]
    const translations = await super.find(0, 100, { masterLanguageEntry: thisContent._id, type: thisContent.type });
    const parent = await super.find(0, 1, { children: id });
    const result = { content: thisContent, translations: translations.data, children: [], parent: parent.data && parent.data.length ? parent.data[0] : null }
    if (thisContent?.children?.length) {
      let ids: any[] = thisContent?.children;
      if (ids[0] && ids[0]['_id']) {
        ids = thisContent.children.map(el => (<any>el)._id);
      }
      const children = await super.find(0, 1000, { _id: { $in: ids } });
      result.children = children.data;
      return result;
    } else {
      return result;
    }
  }

}
